import { mutations as MUTATION } from "./types";

const actions = {
  [MUTATION.COMMON_OPEN_GDIALOG]: (state, { message, type, data }) => {
    state.messages.push({ id: type + '::' + Date.now(), message, type, data });
  },
  [MUTATION.COMMON_CLOSE_GDIALOG]: (state, id) => {
    const index = state.messages.findIndex(x => x.id == id);
    if (index > -1) {
      state.messages.splice(index, 1);
    }
  },
};

export default actions;
